export default __webpack_public_path__ + "static/media/tab_5.08ec5b01.png";